<template>
    <div class="card" ref="screen" v-if="viz.visibleFlag === true" style="height: 100%">
        <div class="card-header d-flex justify-content-between flex-wrap">
           {{viz.vizTitle}}
           <span v-for="n in listBoxScopeName" v-bind:key="n">
                {{n}}
                <select v-model="listBoxData[n]" v-on:change="filterBy">
                    <option :value="undefined">All</option>
                    <option v-for="option in options[n]" v-bind:key="option">{{option.value}}</option>
                </select>
           </span>

           <div v-on:click="fullscreen(showFSButton)">
               <i class="fas fa-expand-alt" style="color:blue" v-if="showFSButton"></i>
               <i class="fas fa-compress-alt" style="color:blue" v-if="!showFSButton"></i>
           </div>

           <a v-on:click="commentBox(viz)" class="txt-color-white right-padding-50">
                <i class="fa fa-lg fa-comments"></i>
           </a>
        </div>
        <div class="card-body">
            <div class="" v-if="viz.viztypeName === 'Beeswarm'">
                <div class="" data-toggle="buttons-radio">
                    <button type="button" class="scale btn btn-secondary ml-2" value="scaleLinear">
                        Linear Scale
                    </button>
                    <button type="button" class="scale btn btn-secondary ml-2" value="scaleLog">
                        Log Scale
                    </button>
                </div>
            </div>
            <div :id="id" ref="r1c1"></div>
        </div>

        <b-modal ref="comment-box" @ok="postAnnotation()" :title="annotationTitle">
            <b-form-group label="Comment">
                <textarea rows="3" cols="40" v-model="cmnt"
                          placeholder="Write a comment..."></textarea>
            </b-form-group>
        </b-modal>
    </div>
</template>
<script>
import {FwVizChartInfo} from "../models";
import axios from "axios";

export default {
        name: 'Viz',
        props: {
            viz: Object
        },
        data: () => ({
           showFSButton:true,
            salesmanData:[],
            listBoxScopeName: [],
            listBoxData:{},
            filterWhereClause:'',
            options:{},
            filterSalesman:'',
            showModal: false,
            cmnt: "",
            annotations: [],
            searching: false,
            annotationTitle: '',
            id: `VIZ-${new Date().getTime()}`
        }),
        methods: {
         fullscreen(showFSButton) {
            if(showFSButton===true) {
                console.log(showFSButton)
                this.$refs.screen.requestFullscreen();
            }else {
                console.log(showFSButton)
                const document=window.document
                document.exitFullscreen();
            }
            this.showFSButton=!this.showFSButton
         },

         loadListBox: function () {
            let listBoxScopeValue=this.$store.state.userRoleRestriction.dimensionAccessPermissionArray
            if(listBoxScopeValue){
                if(listBoxScopeValue.length>0){ // due to role restriction dimensionArray is null in server but empty in local
                    console.log("listBoxScopeValue if condition", listBoxScopeValue)
                    axios.get('/api/listbox/'+ listBoxScopeValue).then(res => {
                        this.salesmanData = res.data
                        this.listBoxScopeName = [ ... new Set(this.salesmanData.map(x => x.dimName))]
                        this.filterSalesman = Array.from(new Set(this.salesmanData.map(c => c.dim1).filter(x => x != null)))
                        console.log("Salesman data:", this.salesmanData)
                        console.log("Salesman data:", this.listBoxScopeName)

                        this.listBoxScopeName.forEach(value => {
                            const vals= this.salesmanData
                                .filter(function(data) { return data.dimName === value })
                                .map(function(x){return {value: x.dim1} })
                                    this.options[value] = Array.from(new Set(vals));
                        });
                        console.log("Option output",this.options)
                    }, err => {
                        console.log('Error in fetching record', err)
                    })
                }
            }
         },
         filterBy: function(e) {
            console.log("Filter name and value", e.target.value);
            console.log("List Box Data ",this.listBoxData);
            this.filterWhereClause = ""
            for ( let key in this.listBoxData) {
                console.log("List Box Data ",this.listBoxData[key]);
                if(this.listBoxData[key]){
                    this.filterWhereClause= this.filterWhereClause +" and "+key+" ='" +this.listBoxData[key]+"' "
                    console.log("Filter Where Clause",this.filterWhereClause);
                }else{
                    this.filterWhereClause=""
                }
            }
            this.loadViz()
         },

         commentBox: function (what) {
            console.log(`ENTERED into the commentBox function(${what.menuName}, ${what.screenName})`)
            this.cmt = '';
            this.pg = what.menuName;
            this.section = what.vizTitle;
            this.annotationHeader = "User Annotations";
            this.annotationTitle = this.annotationHeader + '->' + this.pg + '->' + this.section
            this.$refs['comment-box'].show()
         },

         postAnnotation: function () {
            const url = '/api/annotation';
            const data = {
                userId: 1,
                userName: "Admin",
                page: this.pg,
                section: this.section,
                comment: this.cmnt
            };
            axios.post(url, data).then(() => {
                this.$store.dispatch('loadAnnotations')
            }, e => {
              //  this.$commonFn.auditLog(this.viz.menuSyspk,menu, subMenu, "", "POST", e)
                console.error('error in updating annotations', e)
            })
            let menu = this.pg;
            let subMenu = this.section;
            console.log("the menus and submenus for Audit log is", menu, subMenu)

           // this.$commonFn.auditLog(this.viz.menuSyspk,menu, subMenu, "", "POST", "Success")
         },

         loadViz: function () {
            this.$store.dispatch("loadState").then(() => {
                let allVizType = this.$store.state.vizType
                let v = this.viz
                let margin = {
                    top: v.pmTop,
                    right: v.pmRight,
                    bottom: v.pmBottom,
                    left: v.pmLeft
                }
                console.log("Where clause append",this.filterWhereClause);
                let vizId = v.viztypeId
                let filter = allVizType.filter(t => t.viztypeId === vizId)[0];
            //    let vizname = filter.viztypeName
            //Added for common API class
                let vizname = filter.viztypeClassName
                console.log("vizName in vue",vizname)
                let vizFunction = filter.viztypeFunctionName
                let divId = this.$refs.r1c1
                let vizunit = v.positionLogical
                let getChartInfo = (vizunit) => {
                    let f = v
                    if (f.length === 0) return new FwVizChartInfo(vizunit, margin, {}, false, [])
                     return new FwVizChartInfo(vizunit, margin, f, v.visibleFlag, f)
                }

                this.position = getChartInfo(vizunit)

                let chartData = this.position
                console.log("The chart data is" , chartData, vizname, divId)
                if ( this.$store.state.userRoles.dimensionValueAccessPermissionWhereClause ) {
                    console.log("global where clause", this.$store.state.userRoles.dimensionValueAccessPermissionWhereClause)
                   // let dynamicFwWhereClause = "where client_id=10 " +this.$store.state.userRoles.dimensionValueAccessPermissionWhereClause + this.filterWhereClause
                   // let dynamicFwAndClause = this.$store.state.userRoles.dimensionValueAccessPermissionWhereClause + this.filterWhereClause

                   //replace FW keyword appropriately
                   // chartData.query=chartData.query.replace(/fw_where_clause/gi,dynamicFwWhereClause) //where clause for query with no where clause
                   //chartData.query=chartData.query.replace(/fw_and_clause/gi,dynamicFwAndClause) //and clause for query which has already a where condition
                   //console.log("chart data query where", chartData.query)
                   //splitQuery[0] +"where client_id=10 " +this.$store.state.userRoles.dimensionValueAccessPermissionWhereClause + this.filterWhereClause + " group by" + splitQuery[1]
                }
                console.log("list box scope name", this.$store.state.userRoleRestriction.dimensionAccessPermissionArray)
                console.log("list box scope name", this.$store.state.userRoleRestriction.dimensionValueAccessPermissionArray2d)
                console.log("chart data query where", chartData.query )
                console.log("chart data syspk", chartData.data.syspk )

                setTimeout(() => {
                    this.$commonFn.renderChart(vizname, chartData, divId, vizFunction);
                }, 300)
            })
         }
    },

    created() {
        this.loadListBox()
        this.loadViz()
    }
 }
</script>
<style>
    .cobackground {
        fill: #eee;
    }

    text.active {
        fill: red;
    }
    body {
          height: 15px;
    }
    th {
        position: sticky;
        top: 0;
        white-space: nowrap;
        background-color: white;
    }
    body.container {
        float: left;
        width: 50%;
    }
</style>